module.exports = __webpack_public_path__ + "img/百香果3.acade111.png";